import { Account } from '~redux/account/actions/account';
import { Brand, BrandDetails } from '~redux/brand/types';

export type BrandType =
  | 'visa'
  | 'mastercard'
  | 'jcb'
  | 'amex'
  | 'diners'
  | 'discover'
  | 'unknown';

const BRAND: Record<BrandType, string> = {
  visa: 'Visa',
  mastercard: 'Mastercard',
  jcb: 'JCB',
  amex: 'American Express',
  diners: 'Diners Club',
  discover: 'Discover',
  unknown: 'Unknown',
};

export const formatBrand = (brand: BrandType) => {
  return BRAND[brand];
};

export const isProtectedBrand = (
  brand?: Brand | BrandDetails,
  account?: Account
) => {
  return !brand || !account
    ? true
    : brand.exclude_zip_code?.includes(account.zip_code!);
};

export const isProtected = (
  protectedZipCodes?: string[],
  account?: Account
) => {
  return protectedZipCodes?.includes(account?.zip_code!);
};

export const saveBrandIdToLocalStorage = (brandId: string): void => {
  localStorage.setItem('brandId', brandId);
};

export const retrieveBrandIdFromLocalStorage = () =>
  localStorage.getItem('brandId');

export const deleteBrandIdFromLocalStorage = () =>
  localStorage.removeItem('brandId');
